module.exports = __webpack_public_path__ + "img/four2Red.23434572.jpg";